import Media from './../mediaDetect.js'; //Детектор медиа

let Header = {
    scroll: function(scrollTop, offsetTop){
    	var $header = $('[data-header]'),
            $headerContent = $header.find('[data-header-content]');

        Header.setHeightHeader();

        //if(Media.detect().isDesktop) {
            if (scrollTop > offsetTop){
                $headerContent.addClass('fixed');
                
            } else {
                $headerContent.removeClass('fixed');
            }
        //}
    },
    setHeightHeader: function(){
        var $header = $('[data-header]'),
            $headerContent = $header.find('[data-header-content]'),
            heightHeaderContent = parseInt($headerContent.height());

        $header.height(heightHeaderContent);
    }
}

$(window).on('load', function () {
    var timeIdDelayedMenuOpening;
    var $header = $('[data-header]'),
        $headerContent = $header.find('[data-header-content]'),
        bottomHeader = $headerContent.find('[data-header-bottom]'),
        bottomHeaderOffsetTop = parseInt(bottomHeader.offset().top);

    Header.scroll($(window).scrollTop(), bottomHeaderOffsetTop);

    $(window).on('scroll', function(event) {
        Header.scroll($(window).scrollTop(), bottomHeaderOffsetTop);
    });
    $(window).on('resize', function(event) {
        Header.scroll($(window).scrollTop(), bottomHeaderOffsetTop);
    });

    $('[data-item-bottom-menu-header]').hover(
        function(){
            let $this = $(this);

            if(!window.mousedownMap) {
                clearTimeout(timeIdDelayedMenuOpening);
                timeIdDelayedMenuOpening = setTimeout(function(){
                    var submenu = $this.find('[data-submenu-bottom-menu-header]');

                    submenu.css('display', 'block');
                    submenu.stop().animate({'opacity': 1}, 200);
                }, 500);
            }
        }, function(){
            clearTimeout(timeIdDelayedMenuOpening);

            $(this).find('[data-submenu-bottom-menu-header]').stop().animate({'opacity': 0}, 200, function(){
                $(this).removeAttr('style');
            });
        });
});



// WEBPACK FOOTER //
// ./components/header.js